import { ActionBuilder } from '@cuatroochenta/co-redux-builders';

export default ActionBuilder.build({
    setCheckedIds: (currentId: string) => ( {currentId} ),
    clearReducer: () => ( {} ),
});
